(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  (function(){
    /**
     * Handles toggling the open class on selected top-level links - reveals the submenus on mobile
     */

    let menu_items = document.querySelectorAll('.menu-item-has-children');
    if (!menu_items) return;
    for (let item of menu_items) {
      item.addEventListener('click', (e) => {
        let target = e.currentTarget,  // target could be the a or the li
            targets_li = target.closest('li'),  // but we want it to be the li that we work with
            child_menu = targets_li.querySelector('.sub-menu__list');  // and we'll need to mark the submenu as expended

        if (!child_menu) return;
        // normally, we'd execute this on all <li>s, but as we're already selecting by the
        // menu-item-has-children class, we don't need to do an extra check for child elements.
        // also, right now it's not really a mega menu - there are no sub-sub-menus to look for.
        // so deal with the open class and move on with our lives.
        if (-1 !== targets_li.className.indexOf('open')) {
          targets_li.className = targets_li.className.replace(' open', '');
          child_menu.setAttribute('aria-expanded', 'false');
        } else {
          targets_li.className += ' open';
          child_menu.setAttribute('aria-expanded', 'true');
        }
      }, false);
    }

  })();

}));
